/**
 * 竞价模拟出价路径
 */
export const AUCTION_MOCK_PAGE_PATH = '/auction/mock'
